import { PropsWithCustomComponent, VariantsController } from '../../VariantsController';
import { AccountLoyaltySubpageC } from './accountSubpageC/AccountLoyaltySubpageC';
import { AccountLoyaltySubpageA } from './accountSubpagesA/AccountLoyaltySubpageA';
import { AccountLoyaltySubpageB } from './accountSubpagesB/AccountLoyaltySubpageB';

export interface AccountLoyaltySubpageProps {}

export type AccountLoyaltySubpageVariants = 'A' | 'B' | 'C';

const AccountLoyaltySubpageController = (props: PropsWithCustomComponent<AccountLoyaltySubpageProps>) => (
  <VariantsController<AccountLoyaltySubpageProps, AccountLoyaltySubpageVariants>
    {...props}
    variantsControllerConfig={{
      componentVariants: { A: AccountLoyaltySubpageA, B: AccountLoyaltySubpageB, C: AccountLoyaltySubpageC },
      name: 'AccountLoyaltySubpage',
    }}
  />
);
export { AccountLoyaltySubpageController as AccountLoyaltySubpage };
